/** Carousel 내부 컴포넌트끼리 화살표·페이지네이션 요소와 처음·끝 상태를 공유하는 context — 호출부에서 직접 쓰지 않는다 */

import { createContext, useContext, type Dispatch, type SetStateAction } from 'react';

/** 슬라이드 이동과 무관한 ref/setter 값 */
export type CarouselCtx = {
  prevEl: HTMLDivElement | null;
  nextEl: HTMLDivElement | null;
  paginationEl: HTMLDivElement | null;
  setPrevEl: (el: HTMLDivElement | null) => void;
  setNextEl: (el: HTMLDivElement | null) => void;
  setPaginationEl: (el: HTMLDivElement | null) => void;
  setIsBeginning: Dispatch<SetStateAction<boolean>>;
  setIsEnd: Dispatch<SetStateAction<boolean>>;
};

/** 슬라이드 이동 시 변경되는 네비게이션 상태 — CarouselPrev/Next 전용 */
export type CarouselNavCtx = {
  isBeginning: boolean;
  isEnd: boolean;
};

export const CarouselContext = createContext<CarouselCtx | null>(null);
export const CarouselNavContext = createContext<CarouselNavCtx>({ isBeginning: true, isEnd: false });

export const useCarousel = () => {
  const ctx = useContext(CarouselContext);
  if (!ctx) {
    throw new Error('<Carousel> 또는 <CarouselProvider> 안에서만 사용할 수 있습니다. 슬라이드 안에는 둘 수 없습니다.');
  }
  return ctx;
};

export const useCarouselNav = () => useContext(CarouselNavContext);
